import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { Button } from '@bluebeam/react-skyline-button';
import Indicator from './Indicator';
/**
 * Indicator Group Clean is a type of **molecule** represents users by circular indicators that only appears in the upper-right of the editor UI
 */
const IndicatorGroupClean = ({ children, className, users, onIndicatorClick, maxVisibleIndicators, showTooltip, menuConfig, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    const indicatorBackgroundColors = [
        'bg-real-time-collaboration-blue',
        'bg-real-time-collaboration-red',
        'bg-real-time-collaboration-purple',
        'bg-real-time-collaboration-green',
    ];
    const getPlusSign = () => {
        if (maxVisibleIndicators) {
            if (maxVisibleIndicators < users.length) {
                if (maxVisibleIndicators <= 0) {
                    return null;
                }
                return `+${users.length - maxVisibleIndicators}`;
            }
            if (maxVisibleIndicators >= users.length) {
                return null;
            }
        }
        if (!maxVisibleIndicators && users.length > 4) {
            if (maxVisibleIndicators === 0) {
                return null;
            }
            return `+${users.length - 4}`;
        }
        return null;
    };
    return (_jsx(_Fragment, { children: _jsxs("ol", { className: buildClassName('m-auto flex items-center gap-2 pl-0', className), ...dataAttributes, children: [users.map((user, index) => index < (maxVisibleIndicators ?? 4) && (_jsx("li", { className: "list-none", children: _jsx(Indicator, { className: indicatorBackgroundColors[index % indicatorBackgroundColors.length], firstName: user.firstName, lastName: user.lastName, toolTip: showTooltip, onClick: onIndicatorClick }) }, user.id ?? index))), menuConfig && children ? (_jsxs(_Fragment, { children: [_jsx(Button, { ...menuConfig.triggerProps, className: "text-darker-gray flex min-h-[32px] items-center justify-center p-0", size: "40px", variant: "text", ref: menuConfig.buttonRef, children: getPlusSign() }), menuConfig.isOpen && children] })) : (_jsx("span", { className: "skyline-text-caption-2 text-darker-gray flex min-h-[32px] items-center justify-center", children: getPlusSign() }))] }) }));
};
export default IndicatorGroupClean;
//# sourceMappingURL=IndicatorGroupClean.js.map